export default "__VITE_ASSET__EuBGYx6p__"